// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RR from "common/src/RR.bs.js";
import * as Env from "common/src/Env.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";

function useWindowWidth(param) {
  var match = React.useState(function () {
        return window.innerWidth;
      });
  var setWidth = match[1];
  RR.useIsoLayoutEffect0(function (param) {
        var cb = function (param) {
          return Curry._1(setWidth, (function (param) {
                        return window.innerWidth;
                      }));
        };
        window.addEventListener("resize", cb);
        return (function (param) {
                  window.removeEventListener("resize", cb);
                  
                });
      });
  return match[0];
}

function useWindowHeight(param) {
  if (!Env.isBrowser) {
    return 1080;
  }
  var match = React.useState(function () {
        return window.innerHeight;
      });
  var setHeight = match[1];
  RR.useIsoLayoutEffect0(function (param) {
        var cb = function (param) {
          return Curry._1(setHeight, (function (param) {
                        return window.innerHeight;
                      }));
        };
        window.addEventListener("resize", cb);
        return (function (param) {
                  window.removeEventListener("resize", cb);
                  
                });
      });
  return match[0];
}

export {
  useWindowWidth ,
  useWindowHeight ,
  
}
/* RR Not a pure module */
